import React, { Fragment, useState } from 'react';

import { Dropdown } from 'react-bootstrap';

import { firstLetterToUpperCase } from '../../../../helpers/helpers';
import { PLAYERS_TABLE_CATEGORIES } from '../../../../config/constants';
import { TableHeader as THProps } from '../types';
import { useTablePropertiesDispatch, useTablePropertiesState } from 'store/hooks';

const TableHeader = ({ dropdown, setDropdown } : THProps) => {

  const { orderColumn } = useTablePropertiesState();
  const { changeOrderColumn } = useTablePropertiesDispatch();

  const [isToggled, setIsToggled] = useState(false);

  const handleDropdownChange = (index: number) => {
    setDropdown(PLAYERS_TABLE_CATEGORIES[index]);
    // if is not sorted by players name reset the column order
    if (Math.abs(orderColumn) !== 2) changeOrderColumn(0)();
  };

  type ButtonProps = React.HTMLProps<HTMLButtonElement>;

  const CustomToggle = React.forwardRef<HTMLButtonElement, ButtonProps>(({ children, onClick }, ref) => (
    <button
      id="pv-table-dropdown"
      ref={ref}
      onClick={e => {
        e.preventDefault();
        onClick!(e);
      }}
    >
      {children}
      <img 
        alt="arrow-icon"
        src={"/assets/pv-arrow.svg"} 
        style={isToggled ? { transform: 'rotate(180deg)' } : {}}  />
    </button>
  ));

  return (
    <div className="select-head">
      <Dropdown onToggle={(isOpen: boolean) => setIsToggled(isOpen)}>
        <Dropdown.Toggle as={CustomToggle} id="dropdown-basic" className="dropdown">
          {firstLetterToUpperCase(dropdown)}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {PLAYERS_TABLE_CATEGORIES.map((cat, ind) => {
            if (cat !== dropdown) {
              return (
                <Dropdown.Item key={cat} id={cat} onClick={() => handleDropdownChange(ind)}>
                  {firstLetterToUpperCase(cat)}
                </Dropdown.Item>
              );
            } else {
              return <Fragment key={cat}></Fragment>;
            }
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default TableHeader;